import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import NotifItem from './NotifItem'

class NotifList extends Component {
  	render() {
  		const createNotifItem = (item, index) => {
	    	return <Link to={'/projects/'+item.project_id} key={item.project_id} onClick={() => this.props.handleClick()}>
	    				<NotifItem project={item} id={index} key={index} />
	    			</Link>
	    }

	    return (
			<div className="notificationsListContainer">
				{this.props.projects.map(createNotifItem)}
			</div>
	    );
  	}
}

export default NotifList;



// WEBPACK FOOTER //
// ./src/components/Modal/NotifList.js